import { Typography } from '@sanlam-glacier/app-common/components';
import styles from './transaction-summary-explanation.module.scss';

const TransactionSummaryExplanation = () => {
  return (
    <div data-testid='transactionSummaryExplanation' className={styles.container}>
      <Typography variant={Typography.VARIANT.B4}>
        Any fees indicated are for the statement period, unless otherwise specified.
      </Typography>
      <Typography variant={Typography.VARIANT.B4}>
        Investment price movement for the statement period is: the closing balance, <span className={styles.text}>minus</span> the sum of
        the opening balance <span className={styles.text}>plus</span> all transactions in, <span className={styles.text}>minus</span> all transactions out.
      </Typography>
      <Typography variant={Typography.VARIANT.B4}>
        Total investment return for the statement period is: the sum of any income declarations and
        the investment price movement. Income declarations include the following: interest,
        dividends, REIT income and other income.
      </Typography>
    </div>
  );
};

export default TransactionSummaryExplanation;
